<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
                    <div class="my_fontSize_1Point5 my_fontWeight_600 my_color_00338e ZAfont_family">{{$t('3452')}}</div>
                </div>
                <div class="modal-body">
                    <div style="width: 100%">
                        <select v-model="selectedCustomerName" class="my_select" style="width: 100%">
                            <option v-for="name in customerNameSelection" v-bind:value="name">{{name.text.useTextKey?$t(name.text.textKey):name.text.textUI}}</option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button @click="cancel()" class="btn my_btn_nextConfigurationStep" style="margin-right: 5px">{{$t('3366')}}</button>
                    <button @click="furtherToManualHome()" class="btn my_btn_nextConfigurationStep">{{$t('1023')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import FormData from 'form-data';
    export default {
        props: {
            zlw: '',
        },
        created() {
            this.$store.dispatch('manualHome/get_customerNameSelectionOverview_storeAction');
        },
        computed: {
            customerNameSelection: {
                get() {
                    return this.$store.state.manualHome.customerNameOverviewSelection;
                },
            },
            selectedCustomerName: {
                get() {
                    if (this.$store.state.manualHome.customerNameOverviewSelection != null && Array.isArray(this.$store.state.manualHome.customerNameOverviewSelection)) {
                        const firstIndex_whichMeetConditions = this.$store.state.manualHome.customerNameOverviewSelection.findIndex(i => (i.selected == true));
                        if (firstIndex_whichMeetConditions > -1) {
                            return this.$store.state.manualHome.customerNameOverviewSelection[firstIndex_whichMeetConditions];
                        }
                    }
                    return 'ZA'
                },
                set(value) {
                    this.change_Selected_atElementOf_customerName(value);
                }
            },
        },
        methods: {
            change_Selected_atElementOf_customerName(value) {
                this.$store.dispatch('manualHome/change_customerNameOverview_storeAction', value);
            },
            furtherToManualHome() {
                this.$store.dispatch('manualHome/get_webConfiguration_storeAction', this.zlw);
                this.$emit('close');
            },
            cancel() {
                this.$emit('close');
            }

        }
    }
</script>

<style>
    .modal-mask {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: scroll;
        /*        height: 120%;*/
    }

    .modal-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 650px;
    }

    .modal-container {
        background-color: white;
        border-radius: 10px;
        padding: 20px;
        max-width: 500px;
        width: 100%;
    }

    .modal-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }

        .modal-header h3 {
            margin: 0;
        }

    .modal-body {
        margin-bottom: 20px;
    }

    .modal-footer {
        display: flex;
        justify-content: flex-end;
    }
</style>
